// Global configuration constants
export const CONFIG = {
  // Geoapify API configuration for reverse geocoding
  GEOAPIFY_API_KEY: '43b48c16d2084b809197aaa6db21d937',
  GEOAPIFY_BASE_URL: 'https://api.geoapify.com/v1/geocode/reverse',
  
  // Other app constants can be added here
  APP_NAME: 'Truckoo',
  DEFAULT_TIMEOUT: 10000,
}
